export const Data = [
    {
      question: 'What included Marvel?',
      answer: 'The best stories Marvel, Star Wars and National Geographic, all in one place. • Groupwatch: Share your favorite stories, even when you are far away.'
    },
    {
      question: 'What payment methods can I use?',
      answer: 'You can pay by credit card, debit card, Mercado Pago and even through third parties and local service providers. It is not mandatory to have a bank card.'
    },
    {
      question: 'What does the annual combo do?',
      answer: 'If you have an annual subscription, we will divide the price you paid into 12 equal parts and discount that price monthly from the final Combo+ price.'
    }
  ];
  